type ShortDay = 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun';

export interface IsLiveChatScheduledOptions {
  daysClosed: Array<ShortDay>;
  hourOpen: number | null;
  hourClosed: number | null;
}

/**
 * Whether or not the live chat is scheduled to be operational at `date`.
 * For example, the chat is only available during office hours on weekdays.
 *
 * @param date Time to check against live chat schedule
 * @param options.daysClosed Which days the live chat is unavailable
 * @param options.hourOpen What hour (0-23) the chat should open
 * @param options.hourClosed What hour (0-23) the chat should close
 */
export const isLiveChatScheduled = (date: Date, options: IsLiveChatScheduledOptions): boolean => {
  const [dayString, timeString] = date
    .toLocaleString('en-US', {
      timeZone: 'America/New_York',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    })
    .split(' ');

  const day = dayString as ShortDay;

  // @ts-ignore
  const [hour, minute] = timeString.split(':');

  // @ts-ignore
  const currentTimeInDecimal = +hour + +minute / 60;

  if (options.hourOpen === null || options.hourClosed === null) {
    return false;
  }

  return (
    !options.daysClosed.includes(day) &&
    currentTimeInDecimal >= options.hourOpen &&
    currentTimeInDecimal < options.hourClosed
  );
};
